import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const PADRIGHT = () => {
  return (
    <CardSection id="PADRIGHT" title="PADRIGHT">
      <Paragraph>
        지정된 길이만큼 지정된 문자로 문자열을 채웁니다. 이는 MySQL RPAD와
        동일한 출력을 제공합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>PADRIGHT(STRING, NUMBER, VALUE)</Paragraph>
        <Ul>
          <Li>
            <b>STRING</b>은 적용하려는 텍스트 문자열입니다.
          </Li>
          <Li>
            <b>NUMBER</b>는 전체 문자열의 길이입니다. <b>STRING</b>이 이
            길이보다 짧으면, 부족한 부분을 <b>VALUE</b>로 채웁니다.
          </Li>
          <Li>
            <b>VALUE</b>는 주어진 길이를 채우기 위해 사용되는 문자입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>PADRIGHT(`set`, 10, "-")</Paragraph>
        <Img src="computePadRight" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          <b>STRING</b>의 길이가 이미 <b>NUMBER</b> 이상이면 기존 문자열이
          그대로 반환됩니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
